import { v4 as uuid } from 'uuid';
import { FlowNodeTypes } from '../../../types';
export function createBusinessHoursNode(node, scheduleId) {
    const { payload } = node;
    return Object.assign(Object.assign({}, node), { nodeType: FlowNodeTypes.BUSINESS_HOURS, text: 'Business hours', icon: 'clock', isRemovable: false, payload: {
            scheduleId: scheduleId,
            hangUpAfterAnnouncement: false,
            closedNodeId: uuid(),
            openNodeId: (payload === null || payload === void 0 ? void 0 : payload.openNodeId) || uuid(),
        } });
}
